import { memo } from 'react'
import { useTranslation } from 'react-i18next'

// import { FullCenterContent } from '@shared/ui/wrappers'

import { Wrapper, Content } from './ui'

const FCNoAccessPage = () => {
  const { t } = useTranslation('titles')

  return (
    <>
      <title>{t('titles:noAccess')}</title>

      <Wrapper>
        <Content />
      </Wrapper>
    </>
  )
}

export const NoAccessPage = memo(FCNoAccessPage)
